// @flow
import * as classNames from 'classnames';
import * as React from 'react';
import { withLocalize, Translate } from "react-localize-redux";

import './Footer.css';

interface IFooterProps {
    nextEnabled: boolean;
    nextText?: string;
    backText?: string;
    handleClickBack: () => void;
    handleClickNext: () => void;
}

interface IFooterState {
    
}

class Footer extends React.Component<IFooterProps, IFooterState> {

    constructor(props: IFooterProps) {
        super(props);

        this.state = {
            
        };
    }

    onClickBack = () => {
        this.props.handleClickBack();
    }

    onClickNext = () => {
        if (this.props.nextEnabled) {
            this.props.handleClickNext();
        }
    }

    render() {
        const nextClasses = classNames('Footer-next', {
            'Footer-next--disabled': !this.props.nextEnabled
        });
        return (
            <React.Fragment>
                <div className={'Footer'}>
                    <div className={'Footer-back'} onClick={this.onClickBack}>
                        {this.props.backText ? this.props.backText : 'Back'}
                    </div>
                    <div className={nextClasses} onClick={this.onClickNext}>
                        {this.props.nextText ? this.props.nextText : 'Next'}
                    </div>
                </div>

                <div className="disclaimer">
                    <Translate id="disclaimer" />
                </div>

            </React.Fragment>
        );
    }
}

export default withLocalize(Footer);
